import React, { useState, useEffect } from "react";
import { Flex, Loader, Text } from "@mantine/core";
import { IconPaperclip, IconDownload } from "@tabler/icons-react";
import { saveAs } from "file-saver";
import { EcmNodeContent } from "../../../model/EcmNodeContent";
import { getFileNames } from "../../extension/Extension";
import { ActionIcon } from "@mantine/core";

export interface AttachmentListModalProps {
  fileUrls: string[];
}

export const AttachmentListModal = ({ fileUrls }: AttachmentListModalProps) => {
  const [files, setFiles] = useState<EcmNodeContent[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNames = async () => {
      setLoading(true);
      try {
        const data = await getFileNames(fileUrls);
        if (data) {
          setFiles(data);
        }
      } catch (error) {
        console.error("Error fetching file names:", error);
      } finally {
        setLoading(false);
      }
    };
    if (fileUrls.length > 0) {
      fetchNames();
    } else {
      setLoading(false);
    }
  }, [fileUrls]);

  const handleDownload = async (url: string, fileName: string) => {
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      saveAs(blob, fileName);
    } catch (error) {
      console.error("Download failed:", error);
      window.open(url, "_blank");
    }
  };

  if (loading) {
    return (
      <Flex justify="center" align="center" py="xl">
        <Loader size="sm" />
      </Flex>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        paddingTop: "10px",
      }}
    >
      {fileUrls.map((fileUrl, idx) => {
        const urlFileName = fileUrl.split("/").pop();
        const fileInfo = files.find(
          (f) => f.fileName === urlFileName
        );
        const displayName = fileInfo ? fileInfo.originName : (urlFileName || "File đính kèm");

        return (
          <div
            key={idx}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              border: "1px solid #e9ecef",
              borderRadius: "8px",
              backgroundColor: "#f8f9fa",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                overflow: "hidden",
                flex: 1,
                marginRight: "16px",
              }}
            >
              <IconPaperclip size={20} color="#f59f00" />
              <Text
                size="sm"
                fw={500}
                style={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {displayName}
              </Text>
            </div>
            <ActionIcon
              variant="light"
              color="blue"
              size="lg"
              onClick={() => handleDownload(fileUrl, displayName || "download")}
            >
              <IconDownload size={18} />
            </ActionIcon>
          </div>
        );
      })}
    </div>
  );
};
